// src/modules/reports/hooks/use-report.hook.tsx
import { AuthContext } from "@modules/auth/contexts/auth-plus.context";
import { useContext } from "react";
import { ReportService } from "../services/reports.service";
import { message } from "antd";
import { REPORT_STATUS, REPORT_TYPE } from "../enums/report.enum";
import { ResolveReport } from "../models/report.model";

const service = new ReportService();

export const useReport = () => {
  const { auth, setAuth, logout } = useContext(AuthContext);

  // Xử lý báo cáo
  const resolveReport = async (data: ResolveReport) => {
    try {
      await service.resolveReport(auth, setAuth, logout, data);
    } catch (error) {
      throw error;
    }
  };

  // Lấy danh sách báo cáo
  const getReport = async (
    limit: number = 10,
    page: number = 1,
    status: REPORT_STATUS | "" = "",
    reportType: REPORT_TYPE | "" = "",
    search: string = "",
  ) => {
    try {
      return await service.getAllReportWithFilter(
        auth,
        setAuth,
        logout,
        limit,
        page,
        status,
        reportType,
        search,
      );
    } catch (error) {
      message.error("Không thể tải danh sách báo cáo!");
      throw error;
    }
  };

  const getReportDetailById = async (reportId: string): Promise<any> => {
    try {
      return await service.getReportDetailById(auth, setAuth, logout, reportId);
    } catch (error) {
      throw error;
    }
  };

  return { resolveReport, getReport, getReportDetailById };
};